import axios from 'axios'
import { getAppEndpointVersion } from 'helpers'
import constants from '../constants'

export default function init() {
  console.log('triggers init')
}

export async function list(app, apiHost, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/triggers?per_page=${
    constants.perPageInListings
  }&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: {
        'X-Legacy-Webhook': true,

        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}
export async function listNew(app, apiHost, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/triggers?per_page=${
    constants.perPageInListings
  }&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}
